import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

class FilePicker extends Component {
  constructor(props) {
    super(props);
    this.handleDrop = this.handleDrop.bind(this);
  }

  onFilePickerOpenRequest() {
    this.dropzone.open();
  }

  handleDrop(files) {
    if (_.some(files)) this.props.onFilePicked(files[0]);
  }

  render() {
    return <Dropzone ref={(node) => { this.dropzone = node; }} onDrop={this.handleDrop} multiple={false} style={{ visibility: 'collapse' }} accept={this.props.accept} />;
  }
}

FilePicker.propTypes = {
  onFilePicked: PropTypes.func.isRequired,
  accept: PropTypes.string,
};

export default FilePicker;



// WEBPACK FOOTER //
// ./src/components/FilePicker.js